package com.wintermar.inspection.feature.presentation.inspection.answer.widget.guidance

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction

@Composable
actual fun GuidanceModal(
    show: Boolean,
    question: String,
    guidance: String,
    title: String,
    onDismiss: () -> Unit
) {
    ModalDialog(
        title = title,
        show = show,
        action = ModalAction.default().copy(
            withBackgroundHeader = true,
        ),
        onDismiss = onDismiss
    ) { verticalPadding ->
        Spacer(modifier = Modifier.height(verticalPadding))
        Guidance(
            question = question,
            guidance = guidance
        )
        Spacer(modifier = Modifier.height(verticalPadding))
    }
}
